// extracted by mini-css-extract-plugin
export default {"post":"Post_post__tPrVT","title":"Post_title__5+TY0"};